export default "__VITE_ASSET__a08d0277__"